import { ACCESS_LOG_CREDENTIAL_TYPE } from '../../../config/consts';
import detailMessages from '../../AccessLogDetailModal/messages';
import tooltipMessages from '../messages';

export interface ICredential {
  type?: string;
}

export interface IAccessLog {
  credentials: { type?: string }[];
  result: string;
  detail?: {
    log?: string;
  };
}

type MessageSource = 'tooltip' | 'detail';

const REMOTE_API_LOG = 'Access originator: api';

function isRemoteApiAccess(credential: ICredential | undefined, accessLog: IAccessLog): boolean {
  return credential?.type === ACCESS_LOG_CREDENTIAL_TYPE.REMOTE && accessLog?.detail?.log === REMOTE_API_LOG;
}

export function getAccessTypeMessage(
  credential: ICredential | undefined,
  accessLog: IAccessLog,
  source: MessageSource = 'tooltip'
) {
  if (isRemoteApiAccess(credential, accessLog)) {
    return source === 'tooltip'
      ? tooltipMessages.accessLogResultIconAccessTypeTooltipRemoteApi
      : detailMessages.accessTypeRemoteApi;
  }

  const messagesMap = source === 'tooltip' ? tooltipMessagesMap : detailMessagesMap;
  const unknownMessage =
    source === 'tooltip'
      ? tooltipMessages.accessLogResultIconAccessTypeTooltipUnknown
      : detailMessages.accessTypeUnknown;

  return messagesMap[credential?.type as keyof typeof messagesMap] ?? unknownMessage;
}

export const tooltipMessagesMap = {
  [ACCESS_LOG_CREDENTIAL_TYPE.LICENSE_PLATE]: tooltipMessages.accessLogResultIconAccessTypeTooltipLicensePlate,
  [ACCESS_LOG_CREDENTIAL_TYPE.MOBILE_KEY]: tooltipMessages.accessLogResultIconAccessTypeTooltipMobileKey,
  [ACCESS_LOG_CREDENTIAL_TYPE.CARD]: tooltipMessages.accessLogResultIconAccessTypeTooltipCard,
  [ACCESS_LOG_CREDENTIAL_TYPE.FINGER_PRINT]: tooltipMessages.accessLogResultIconAccessTypeTooltipFingerPrint,
  [ACCESS_LOG_CREDENTIAL_TYPE.CODE]: tooltipMessages.accessLogResultIconAccessTypeTooltipCode,
  [ACCESS_LOG_CREDENTIAL_TYPE.QR_CODE]: tooltipMessages.accessLogResultIconAccessTypeTooltipQrCode,
  [ACCESS_LOG_CREDENTIAL_TYPE.REMOTE]: tooltipMessages.accessLogResultIconAccessTypeTooltipRemoteCall,
  [ACCESS_LOG_CREDENTIAL_TYPE.REX]: tooltipMessages.accessLogResultIconAccessTypeTooltipRex,
  [ACCESS_LOG_CREDENTIAL_TYPE.MAPI]: tooltipMessages.accessLogResultIconAccessTypeTooltipRemoteApi,
  [ACCESS_LOG_CREDENTIAL_TYPE.PAPI]: tooltipMessages.accessLogResultIconAccessTypeTooltipRemoteApi,
} as const;

export const detailMessagesMap = {
  [ACCESS_LOG_CREDENTIAL_TYPE.LICENSE_PLATE]: detailMessages.accessTypeLicensePlate,
  [ACCESS_LOG_CREDENTIAL_TYPE.MOBILE_KEY]: detailMessages.accessTypeMobileKey,
  [ACCESS_LOG_CREDENTIAL_TYPE.CARD]: detailMessages.accessTypeCard,
  [ACCESS_LOG_CREDENTIAL_TYPE.FINGER_PRINT]: detailMessages.accessTypeFingerPrint,
  [ACCESS_LOG_CREDENTIAL_TYPE.CODE]: detailMessages.accessTypeCode,
  [ACCESS_LOG_CREDENTIAL_TYPE.QR_CODE]: detailMessages.accessTypeQrCode,
  [ACCESS_LOG_CREDENTIAL_TYPE.REMOTE]: detailMessages.accessTypeRemoteCall,
  [ACCESS_LOG_CREDENTIAL_TYPE.REX]: detailMessages.accessTypeRex,
  [ACCESS_LOG_CREDENTIAL_TYPE.MAPI]: detailMessages.accessTypeRemoteMapi,
  [ACCESS_LOG_CREDENTIAL_TYPE.PAPI]: detailMessages.accessTypeRemotePapi,
} as const;
